// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innovations-section{
  position: relative;
  height: 100vh;
}

.phonee h3{
  display: none;
}

.phone-tit{
  display: none;
}

@media(max-width:998px){
  .innovations-section{
    height: -moz-fit-content;
    height: fit-content;
  }
  .deskk{
    display: none;
  }

  .phonee{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: -moz-fit-content;
    height: fit-content;
    overflow: hidden;
    width: 100%;
    overflow-y:scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .phonee::-webkit-scrollbar{display: none;}

  .phonee h3{
    color: var(--text-color);
    position: relative;
    display: flex;
    text-align: center;
    margin-bottom: 1.5rem;
    display: flex;
    font-size: 8.5vw;
    margin-top: 30%;
  }

  .phone-tit{
    position: relative;
    display: flex;
    height: -moz-fit-content;
    height: fit-content;
    overflow: hidden;
    overflow-y:scroll!important;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .phone-tit::-webkit-scrollbar{display: none;}

  .heading-ino h1{
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Innovations/Innovations.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA,2BAA2B,aAAa,CAAC;;EAEzC;IACE,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;EAC1B;EACA,8BAA8B,aAAa,CAAC;;EAE5C;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".innovations-section{\n  position: relative;\n  height: 100vh;\n}\n\n.phonee h3{\n  display: none;\n}\n\n.phone-tit{\n  display: none;\n}\n\n@media(max-width:998px){\n  .innovations-section{\n    height: fit-content;\n  }\n  .deskk{\n    display: none;\n  }\n\n  .phonee{\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: fit-content;\n    overflow: hidden;\n    width: 100%;\n    overflow-y:scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .phonee::-webkit-scrollbar{display: none;}\n\n  .phonee h3{\n    color: var(--text-color);\n    position: relative;\n    display: flex;\n    text-align: center;\n    margin-bottom: 1.5rem;\n    display: flex;\n    font-size: 8.5vw;\n    margin-top: 30%;\n  }\n\n  .phone-tit{\n    position: relative;\n    display: flex;\n    height: fit-content;\n    overflow: hidden;\n    overflow-y:scroll!important;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  .phone-tit::-webkit-scrollbar{display: none;}\n\n  .heading-ino h1{\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
